import { useSharableState, useSharableStates, view } from '@esui/core';
import { numberFormatter } from '@esui/core/formatters';
import { HSTack } from '@esui/core/layout/index.js';
import { DemoPage } from '../@demo/utils.js';
import { Button } from '../button/index.js';
import { Textfield } from '../textfield/index.js';
import { Snackbar } from './index.js';

export const [SnackbarDemo] = view('esui-material-snackbar-demo', {
  Props: class {},
  template() {
    const timeout = useSharableState(5000);

    const [defaultOpen, leadingOpen, stackedOpen] = useSharableStates(
      false,
      false,
      false
    );

    return DemoPage(
      HSTack(
        Button('Default')
          .raised()
          .onClick(() => {
            defaultOpen.value = true;
          }),
        Button('Leading')
          .raised()
          .onClick(() => {
            leadingOpen.value = true;
          }),
        Button('Stacked')
          .raised()
          .onClick(() => {
            stackedOpen.value = true;
          }),

        Textfield('snackbar timeout (ms)', timeout)
          .formatter(numberFormatter())
          .helper('4000ms - 10000ms or -1')
          .type('number'),

        Snackbar(defaultOpen, "Can't send photo. Retry in 5 seconds.")
          .actionButtonLabel('Retry')
          .dismissButtonIcon('close')
          .timeoutMs(timeout.value),

        Snackbar(leadingOpen, "Can't send photo. Retry in 5 seconds.")
          .actionButtonLabel('Retry')
          .dismissButtonIcon('close')
          .timeoutMs(timeout.value)
          .leading(),

        Snackbar(stackedOpen, "Can't send photo. Retry in 5 seconds.")
          .actionButtonLabel('Retry')
          .dismissButtonIcon('close')
          .timeoutMs(timeout.value)
          .stacked()
      )
    );
  },
});
